import { Component, OnInit ,Input} from '@angular/core';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { CommonService } from 'src/app/services/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-help-view',
  templateUrl: './help-view.component.html',
  styleUrls: ['./help-view.component.scss']
})
export class HelpViewComponent implements OnInit {
 @Input() public Content: any;
  content: any;
  faqs: FAQ[];
  user_type;
  userDetails : any
  grantFeatures: any[] = [];
  ISTFeatures: any[] = [];
  program:any;
  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private userService : UserService,
    private https: HttpClient
  ) { }

  ngOnInit() {
    
    this.userDetails = this.userService.getUserDetais();
    
    const headers = new HttpHeaders().set('Content-Type', 'text/html; charset=utf-8');
    let path = this.Content.content.module + '/' + this.Content.content.path + ".html";
     this.user_type = this.Content.content.userType;
  //    this.program = this.Content.content.module;

  // this.grantFeatures= this.userDetails.FEATURES.filter(function (item) {
  //     return (item.Id == "grantsconsole")
  //   })[0];
  //   this.ISTFeatures= this.userDetails.FEATURES.filter(function (item) {
  //     return (item.Id == "istconsole")
  //   })[0];

  //   this.https.get('../assets/api/common/help/' + path.toLowerCase(), { headers, responseType: 'text'}).subscribe((data:any) => {
  //    this.help = data;
  //  })


  }

}
